<template>
  <div class="header-container mb">
    <h2 :class="['flex-1', 'center-content', disabled ? 'disabled' : '']" v-if="props.title">{{ props.title }}</h2>
    <div class="flex-1 mr light-blue-border center-content">
      <div class="inline-block" style="border-right: 2px solid #306fb9;">
        <i class="pi pi-search light-blue-text"></i>
      </div>
      <div class="inline-block" style="width: 85%;">
        <InputText :id="getId('search')" v-model="searchText"
                   :placeholder="'Search ' + (props.searchText ? props.searchText : props.title) + '...'"
                   class="no-border transparent-input full-width" name="search"></InputText>
      </div>
    </div>
    <div class="flex-1 light-blue-border center-content">
      <Dropdown v-model="selectedSort" :options="sortOptions" class="no-border transparent-input full-width"
                option-label="name">
        <template #value="slotProps">
          <div v-if="slotProps.value">
            <div class="text-sm light-blue-text">Sort By:</div>
            <div>{{ slotProps.value.name }} <span class="light-blue-text">
                <template v-if="selectedSort.code === 'date' && sortOrder === 'desc'">
                  (most recent first)
                </template>
                <template v-else-if="selectedSort.code === 'date' && sortOrder === 'asc'">
                  (most recent last)
                </template>
                <template v-else-if="selectedSort.code === 'alphabetical' && sortOrder === 'desc'">
                  (A-Z)
                </template>
                <template v-else-if="selectedSort.code === 'alphabetical' && sortOrder === 'asc'">
                  (Z-A)
                </template>
              </span></div>
          </div>
          <span v-else>
              {{ slotProps.placeholder }}
            </span>
        </template>
      </Dropdown>
    </div>
    <div class="light-blue-border center-content" style="white-space: nowrap; border-left: none;">
      <i :class="['pi', 'pi-arrow-up', 'sort-icon', sortOrder === 'asc' ? 'active' : 'inactive']"
         @click="setSort('asc')"></i>
      <i :class="['pi', 'pi-arrow-down', 'sort-icon', sortOrder === 'desc' ? 'active' : 'inactive']"
         @click="setSort('desc')"></i>
    </div>
    <slot></slot>
  </div>
</template>
<script setup>
import { refDebounced } from "@vueuse/core";
import { ref, watch } from "vue";
import { useUnique } from "../composables/ui.js";

const props = defineProps({
  title: String,
  searchText: String,
  disabled: Boolean
})

const emit = defineEmits(
    ['search', 'sort', 'sortOrder']
)

const { getId } = useUnique()

const sortOptions = [
  { name: 'Date Added', code: 'date' },
  { name: 'Alphabetical', code: 'alphabetical' },
]
const sortOrder = ref('desc')
const selectedSort = ref(sortOptions[0])

function setSort(v) {
  sortOrder.value = v
}

const searchText = ref('')

const searchTextDebounced = refDebounced(searchText, 400)

watch(searchTextDebounced, (newValue) => {
  emit('search', newValue)
}, { immediate: true })
watch(selectedSort, (newValue) => {
  emit('sort', newValue)
}, { immediate: true })
watch(sortOrder, (newValue) => {
  emit('sortOrder', newValue)
}, { immediate: true })

</script>

<style scoped>

@media (min-width: 1024px) {
  .header-container {
    display: flex;
  }
}
@media (max-width: 1023px) {
  .light-blue-border {
    padding: 0;
    width: 100%;
    margin-bottom: .5em;
  }

  .pi.pi-search {
    margin-left: .5em;
  }
}
</style>